<template>
  <div class="personswiper-box">
    <!-- 人物轮播 -->
    <Swiper :teamList="teamList" />
    <!-- 下方图文 -->
    <div class="text">
      <div class="left">
        <span>Detial</span> <span>Passion</span> <span>Create</span>
        <span>Link</span> <span>Diversity</span> <span>Innovation</span>
      </div>
      <div class="right">
        <span>注重每一个细节</span> <span>充满无限热情和激情</span>
        <span>富有创造力</span> <span>连接品牌用户</span>
        <span>多元化工作方式</span> <span>保持努力创新</span>
        <span>敢于颠覆思想</span> <span>挑战给定解决方案</span>
        <span>只为脱颖而出</span> <span>创造独特数字体验</span>
      </div>
    </div>
    <!-- 图片 -->
    <img src="@/assets/team/pic.png" alt="" class="pic" />
  </div>
</template>
<script>
import Swiper from "./components/Swiper";
export default {
  props: {
    teamList: {
      type: Array,
      default: () => [],
    },
  },
  components: { Swiper },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
